// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// CollectionSelectModal imports
const actions = require('client-v2/common/containers/collection-select-modal/actions')
const selectors = require('client-v2/common/containers/collection-select-modal/selectors')
// Sibling imports
const AddToCollectionModal = require('./modal-dumb')

function mapStateToProps(state) {
  if (!selectors.isLightweightModalVisible(state)) {
    return { isVisible: false }
  }
  return {
    // Flags
    isCreateButtonDisabled: selectors.isCreatePending(state),
    isCreateButtonVisible: selectors.canCreateFromFilter(state),
    isCollectionsLoaded: selectors.isCollectionsLoaded(state),
    isCollectionsFailed: selectors.isCollectionsFailed(state),
    isFilteredCollectionsEmpty: selectors.isFilteredCollectionsEmpty(state),
    isUnfilteredCollectionsEmpty: selectors.isUnfilteredCollectionsEmpty(state),
    isUnmixDisabled: selectors.isUnmixPending(state),
    isUnmixButtonVisible: selectors.isArticleUnmixable(state),
    isUnmixPromptVisible: selectors.isUnmixPromptVisible(state),
    isVisible: true,
    // Values
    collections: selectors.filteredCollections(state),
    filterText: selectors.filterText(state)
  }
}

const mapDispatchToProps = {
  onCollectionClick: actions.toggleCollection,
  onDismiss: actions.hide,
  onFilterSubmit: actions.createCollectionFromFilter,
  onFilterTextChange: actions.setFilterText,
  onRetry: actions.fetch,
  onUnmix: actions.showUnmixPrompt,
  onUnmixPromptCancel: actions.cancelUnmix,
  onUnmixPromptConfirm: actions.confirmUnmix
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  /**
   * Allow `ownProps` to override `dispatchProps`;
   * needed by `ContentAddModalUrlSubmitted` component
   */
  return { ...stateProps, ...dispatchProps, ...ownProps }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  withIsVisible(
    withImmutableToJS(
      AddToCollectionModal
    )
  )
)
